import React from "react";
import Label from "./Label";

const Select = ({ options, value, label, onChange, className, disabled=false }) => {
  if (!options.length) {
    throw new Error("missing options");
  }

  return (
    <div className={`flex flex-col mb-1 ${className}`}>
      {label ? <Label disabled={disabled}>{label}</Label> : null}
      <select
        className="mt-1 mb-2 px-2 py-2 pr-10  text-black-500 disabled:text-black-300  border shadow-sm focus:ring-am-500 focus:border-black-500 block w-full sm:text-sm border-gray-300 disabled:opacity-50"
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {options.map(({ value, name, disabled=false }, i) => (
          <option key={value || `___${i}`} value={value} disabled={disabled}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};
export default Select;
